import React from "react";
import OdooServices from "./OdooServices";
import HeroSection from "../common/HeroSection";
import ServiceSidebar from "../services/ServiceSidebar";
import {
  BookOpen,
  Briefcase,
  ChartNoAxesColumn,
  ChartPie,
  CircleCheckBig,
  Clock,
  Code,
  Database,
  Globe,
  Layers,
  PanelsTopLeft,
  PenTool,
  RefreshCw,
  Server,
  Settings,
  Shield,
  ShoppingCart,
  Truck,
  Users,
  Zap,
} from "lucide-react";

export default function OffshoreDevelopment() {
  return (
    <div>
      <HeroSection
        title="Odoo Offshore Development Services"
        breadcrumb={[
          { name: "Services", url: "/services" },
          { name: "Odoo Services", url: "/services/odoo-services" },
          {
            name: "Odoo OffshoreDevelopment",
            url: "/services/odoo-services/offshore-development",
          },
        ]}
        background="/assets/images/about/bg.png"
      />
      <div className="bg-white">
        <div className="py-16 px-4 mx-auto container">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 px-4">
            {/* Sidebar (OdooServices) */}
            <OdooServices />

            {/* <!-- Content Section --> */}
            <div className="lg:col-span-2">
              <div>
                <div className="relative rounded-xl overflow-hidden mb-8">
                  <img
                    alt="Odoo Offshore Development Services"
                    loading="lazy"
                    width="400"
                    height="450"
                    decoding="async"
                    data-nimg="1"
                    className="w-full h-auto object-cover rounded-xl"
                    src="/assets/images/odoo/odoo-developer.png"
                  />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Odoo{" "}
                  <span className="text-primary">Offshore Development</span>{" "}
                  Services
                </h2>
                <p className="text-gray-600 mb-6">
                  Our Odoo Offshore Development Services provide you with
                  skilled Odoo developers who work as an extended part of your
                  team—delivering high-quality, cost-effective, and scalable
                  solutions. From custom module development to integrations and
                  upgrades, we ensure your Odoo environment is tailored to your
                  unique business needs.
                </p>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Key Services
                </h3>
                <div className="grid grid-cols-1 gap-4">
                  <div className="p-6 rounded-xl shadow-soft border border-gray-100">
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Custom Odoo app & module development
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Odoo integration with third-party systems
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Odoo migration & upgrade support
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Dedicated offshore Odoo development team
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Ongoing maintenance & technical support
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Key Advantages of Offshore Development
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Clock className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Cost Efficiency
                    </h4>
                    <p className="text-gray-600">
                      Reduce development costs while maintaining high-quality
                      standards.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Globe className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Global Talent Access
                    </h4>
                    <p className="text-gray-600">
                      Work with skilled Odoo developers worldwide.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Server className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Scalable Resources
                    </h4>
                    <p className="text-gray-600">
                      Easily scale your team based on project requirements.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Shield className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Focus on Core Business
                    </h4>
                    <p className="text-gray-600">
                      Let us handle technical challenges while you focus on
                      growth.
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Advantages
                </h3>
                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <div className="grid grid-cols-1 gap-4">
                    {[
                      "<strong>Cost Efficiency</strong> – Access expert talent at reduced costs",
                      "<strong>Scalability</strong> – Easily scale your team as projects grow",
                      "<strong>Faster Delivery</strong> – Agile offshore teams ensure quicker turnaround",
                      "<strong>Expertise</strong> – Certified Odoo developers with industry experience",
                      "<strong>Flexibility</strong> – Engagement models to fit your business needs"
                    ].map((benefit, index) => (
                      <div className="flex items-start" key={index}>
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                        <span
                          className="text-gray-700"
                          dangerouslySetInnerHTML={{ __html: benefit }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Get Started with Offshore Odoo Development
                </h3>
                <p className="text-gray-600 mb-6">
                  Contact our team today to discuss how we can help you
                  implement, customize, and maintain your Odoo system.
                </p>
                <a
                  className="inline-block bg-primary text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300"
                  href="/contact-us/"
                >
                  Request a Free Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How do you handle time zone differences?
                </h3>
                <p className="text-gray-600">
                  We ensure overlapping work hours, use asynchronous
                  communication tools, and provide detailed daily updates to
                  maintain project momentum.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  What if we need to scale our team quickly?
                </h3>
                <p className="text-gray-600">
                  Our offshore development model allows for quick team scaling,
                  with a bench of pre-vetted Odoo experts who can be onboarded
                  as needed.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How do you ensure quality with offshore teams?
                </h3>
                <p className="text-gray-600">
                  We follow strict coding standards, conduct regular code
                  reviews, and implement comprehensive testing protocols to
                  maintain high quality.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  What happens if there are communication issues?
                </h3>
                <p className="text-gray-600">
                  We assign dedicated project managers, maintain multiple
                  communication channels, and use structured documentation to
                  ensure smooth collaboration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
